import { render, staticRenderFns } from "./Prefecture.vue?vue&type=template&id=04ab2720&scoped=true&"
import script from "./Prefecture.vue?vue&type=script&lang=js&"
export * from "./Prefecture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ab2720",
  null
  
)

export default component.exports